<div>
  @for (event of events(); track $index; let index = $index) {
    <div class="flex gap-4">
      <div class="min-w-[4.5rem] max-w-[4.5rem] md:min-w-[9rem] md:max-w-[9rem]">
        <span class="text-[1.125rem]/[160%] font-light text-[#505760]">{{ getFormattedDate(event.date) }}</span>
      </div>
      <div class="relative flex flex-col items-center px-[0.09375rem]">
        @if (event.date) {
          <div class="size-[0.625rem] rounded-full bg-[#0D9443]"></div>
        } @else {
          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
            <circle cx="5" cy="5" r="4" fill="#FCFCFC" stroke="#AFB2B6" stroke-width="2" />
          </svg>
        }
        @if (index !== events().length - 1) {
          @if (event.date) {
            <div class="h-full w-[0.1rem] bg-[#8A8E94]"></div>
          } @else {
            <div class="h-full w-[0.1rem] bg-[#F0F0F0]"></div>
          }
        }
      </div>
      <div class="flex flex-col pb-6">
        @if (event.date) {
          <span class="text-[1.125rem]/[160%] font-medium text-[#222528]">{{
            event.title?.locale | translate: event.title?.value
          }}</span>
          <span class="text-[0.9375rem]/[160%] text-[#505760]">{{
            event.description?.locale | translate: event.description?.value
          }}</span>
        } @else {
          <span class="text-[1.125rem]/[160%] font-medium text-[#505760]">{{
            event?.title?.locale | translate: event.title?.value
          }}</span>
          <span class="text-[0.9375rem]/[160%] text-[#8A8E94]">{{
            event.description?.locale | translate: event.description?.value
          }}</span>
        }
        @if (event.suggestion) {
          <div class="mt-2 rounded-lg bg-[#EEEEEF] p-2">
            <span class="text-[#8A8E94] text-[0.9375rem]">"{{ event.suggestion }}"</span>
          </div>
        }
      </div>
    </div>
  }
</div>
